import { SxProps, Theme } from '@mui/material';

type TStyles = {
  titleInfo: SxProps<Theme>;
  tableInput: SxProps<Theme>;
  wrapper: SxProps<Theme>;
};

export const styles: TStyles = {
  titleInfo: () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 1,
    pb: 1,
  }),

  tableInput: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '& .MuiInputBase-root': {
      minHeight: 'unset',
      fontSize: 'inherit',
    },
    width: '160px',
  },

  wrapper: (theme: Theme) => ({
    backgroundColor: 'var(--main-color-with-opacity-03)',
    padding: '30px 25px',
    marginBottom: '20px',
    borderRadius: '10px',
    border: `1px solid ${theme.palette.grey.additionalGrey}`,
    boxShadow: '2px 2px 10px 0 var(--additional-dark-gray-with-opacity-eight)',
    width: '100%',
  }),
};
